import React from 'react';
import { withTheme, Theme, duration, useTheme } from '@material-ui/core';
import { useSpring, animated } from 'react-spring';

export interface VinylIllustrationProps {
  progress?: number;
  spinning?: boolean;
  theme?: Theme;
}

export interface VinylIllustrationState {}

function VinylWithPlayerArm(props) {
  const theme = useTheme();
  const color1 = theme.palette.primary.dark;
  const color2 = theme.palette.primary.main;

  const { transform } = useSpring({
    from: { transform: 0 },
    to: { transform: props.spinning ? 360 : 0 },
    config: { duration: props.spinning ? 3500 : 0 },
    loop: props.spinning,
  }) as any;

  return (
    <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 375 413">
      <defs>
        <clipPath id="_clipPath_IQDRmhxhyXY0r5UEQXFfaFSfbAo9K4K5">
          <rect width="375" height="413" />
        </clipPath>
      </defs>
      <g clipPath="url(#_clipPath_IQDRmhxhyXY0r5UEQXFfaFSfbAo9K4K5)">
        <rect width="375" height="413" fill="rgb(217,106,106)" fillOpacity="0" />
        <animated.g transform={transform.interpolate(x => `rotate(${x}, 187.5, 218.5)`)}>
          <g>
            <path
              d=" M 0 218.5 C 0 115.016 84.016 31 187.5 31 C 290.984 31 375 115.016 375 218.5 C 375 321.984 290.984 406 187.5 406 C 84.016 406 0 321.984 0 218.5 Z  M 177.966 218.5 C 177.966 213.238 182.238 208.966 187.5 208.966 C 192.762 208.966 197.034 213.238 197.034 218.5 C 197.034 223.762 192.762 228.034 187.5 228.034 C 182.238 228.034 177.966 223.762 177.966 218.5 Z "
              fillRule="evenodd"
              fill="rgb(5,4,9)"
            />
            <path
              d=" M 6.356 218.5 C 6.356 118.524 87.524 37.356 187.5 37.356 C 287.476 37.356 368.644 118.524 368.644 218.5 C 368.644 318.476 287.476 399.644 187.5 399.644 C 87.524 399.644 6.356 318.476 6.356 218.5 Z  M 177.966 218.5 C 177.966 213.238 182.238 208.966 187.5 208.966 C 192.762 208.966 197.034 213.238 197.034 218.5 C 197.034 223.762 192.762 228.034 187.5 228.034 C 182.238 228.034 177.966 223.762 177.966 218.5 Z "
              fillRule="evenodd"
              fill="rgb(11,9,22)"
              vectorEffect="non-scaling-stroke"
              strokeWidth="2"
              stroke="rgb(5,4,9)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
            <path
              d=" M 31.78 218.5 C 31.78 132.556 101.556 62.78 187.5 62.78 C 273.444 62.78 343.22 132.556 343.22 218.5 C 343.22 304.444 273.444 374.22 187.5 374.22 C 101.556 374.22 31.78 304.444 31.78 218.5 Z "
              fill="none"
              vectorEffect="non-scaling-stroke"
              strokeWidth="0.5"
              stroke="rgb(5,4,9)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
            <path
              d=" M 18 218.5 C 18 124.95 93.95 49 187.5 49 C 281.05 49 357 124.95 357 218.5 C 357 312.05 281.05 388 187.5 388 C 93.95 388 18 312.05 18 218.5 Z "
              fill="none"
              vectorEffect="non-scaling-stroke"
              strokeWidth="0.5"
              stroke="rgb(5,4,9)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
            <path
              d=" M 58.792 218.5 C 58.792 147.464 116.464 89.792 187.5 89.792 C 258.536 89.792 316.208 147.464 316.208 218.5 C 316.208 289.536 258.536 347.208 187.5 347.208 C 116.464 347.208 58.792 289.536 58.792 218.5 Z "
              fill="none"
              vectorEffect="non-scaling-stroke"
              strokeWidth="0.5"
              stroke="rgb(5,4,9)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
            <path
              d=" M 45 218.5 C 45 139.852 108.852 76 187.5 76 C 266.148 76 330 139.852 330 218.5 C 330 297.148 266.148 361 187.5 361 C 108.852 361 45 297.148 45 218.5 Z "
              fill="none"
              vectorEffect="non-scaling-stroke"
              strokeWidth="0.5"
              stroke="rgb(5,4,9)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
            <path
              d=" M 88.983 218.5 C 88.983 164.127 133.127 119.983 187.5 119.983 C 241.873 119.983 286.017 164.127 286.017 218.5 C 286.017 272.873 241.873 317.017 187.5 317.017 C 133.127 317.017 88.983 272.873 88.983 218.5 Z "
              fill="none"
              vectorEffect="non-scaling-stroke"
              strokeWidth="0.5"
              stroke="rgb(0,0,0)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
            <path
              d=" M 102 218.5 C 102 171.311 140.311 133 187.5 133 C 234.689 133 273 171.311 273 218.5 C 273 265.689 234.689 304 187.5 304 C 140.311 304 102 265.689 102 218.5 Z "
              fill="none"
              vectorEffect="non-scaling-stroke"
              strokeWidth="0.5"
              stroke="rgb(0,0,0)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
            <path
              d=" M 74 218.5 C 74 155.858 124.858 105 187.5 105 C 250.142 105 301 155.858 301 218.5 C 301 281.142 250.142 332 187.5 332 C 124.858 332 74 281.142 74 218.5 Z "
              fill="none"
              vectorEffect="non-scaling-stroke"
              strokeWidth="0.5"
              stroke="rgb(0,0,0)"
              strokeLinejoin="miter"
              strokeLinecap="square"
              strokeMiterlimit="3"
            />
          </g>
          <path
            d=" M 171.158 218.5 L 84 218.5 C 84 275.623 130.377 322 187.5 322 C 244.623 322 291 275.623 291 218.5 L 203.842 218.5 L 203.842 218.5 C 203.842 227.519 196.519 234.842 187.5 234.842 C 178.481 234.842 171.158 227.519 171.158 218.5 L 171.158 218.5 Z "
            fill="rgb(215,215,215)"
          />
          <path
            d=" M 203.842 218.5 L 291 218.5 C 291 161.377 244.623 115 187.5 115 C 130.377 115 84 161.377 84 218.5 L 171.158 218.5 C 171.158 209.481 178.481 202.158 187.5 202.158 C 196.519 202.158 203.842 209.481 203.842 218.5 Z "
            fill="rgb(255,255,255)"
          />
          <mask id="_mask_rOQf5qJ5JvqjidwjxXg20EUHUn3PMSRB">
            <circle
              vectorEffect="non-scaling-stroke"
              cx="187.5"
              cy="218.5"
              r="107.5000000000001"
              fill="white"
              stroke="none"
            />
          </mask>
          <circle
            vectorEffect="non-scaling-stroke"
            cx="187.5"
            cy="218.5"
            r="107.5000000000001"
            fill="none"
          />
          <linearGradient id="_lgradient_4" x1="0" y1="0.5" x2="1" y2="0.5">
            <stop offset="0%" stopOpacity="1" stopColor={color1} />
            <stop offset="100%" stopOpacity="1" stopColor={color2} />
          </linearGradient>
          <circle
            vectorEffect="non-scaling-stroke"
            cx="187.5"
            cy="218.5"
            r="107.5000000000001"
            fill="none"
            mask="url(#_mask_rOQf5qJ5JvqjidwjxXg20EUHUn3PMSRB)"
            strokeWidth="10"
            stroke="url(#_lgradient_4)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
          <clipPath id="_clipPath_Huy1dRjSLrdG9zTE1jPWvfNxFzh4XJTD">
            <rect
              x="148.362"
              y="147.576"
              width="78.276"
              height="25.424"
              transform="matrix(1,0,0,1,0,0)"
              fill="rgb(255,255,255)"
            />
          </clipPath>
          <g clipPath="url(#_clipPath_Huy1dRjSLrdG9zTE1jPWvfNxFzh4XJTD)">
            <g>
              <g>
                <path
                  d=" M 162.991 161.23 L 162.991 161.23 L 162.991 160.425 L 165.268 160.014 L 165.268 161.127 L 165.268 161.127 Q 165.285 162.034 165.738 162.488 L 165.738 162.488 L 165.738 162.488 Q 166.192 162.941 166.945 162.941 L 166.945 162.941 L 166.945 162.941 Q 167.681 162.941 168.118 162.462 L 168.118 162.462 L 168.118 162.462 Q 168.554 161.983 168.554 161.178 L 168.554 161.178 L 168.554 152.79 L 170.917 152.79 L 170.917 161.178 L 170.917 161.178 Q 170.917 162.856 169.804 164.02 L 169.804 164.02 L 169.804 164.02 Q 168.691 165.184 166.962 165.184 L 166.962 165.184 L 166.962 165.184 Q 165.165 165.184 164.078 164.097 L 164.078 164.097 L 164.078 164.097 Q 162.991 163.01 162.991 161.23 Z  M 181.085 164.927 L 178.911 164.927 L 178.911 164.927 Q 178.842 164.585 178.842 164.02 L 178.842 164.02 L 178.842 164.02 Q 178.517 164.585 177.875 164.867 L 177.875 164.867 L 177.875 164.867 Q 177.233 165.15 176.514 165.15 L 176.514 165.15 L 176.514 165.15 Q 175.025 165.15 174.169 164.2 L 174.169 164.2 L 174.169 164.2 Q 173.313 163.25 173.313 161.829 L 173.313 161.829 L 173.313 156.505 L 175.59 156.505 L 175.59 161.367 L 175.59 161.367 Q 175.59 162.12 175.984 162.591 L 175.984 162.591 L 175.984 162.591 Q 176.377 163.061 177.13 163.061 L 177.13 163.061 L 177.13 163.061 Q 177.867 163.061 178.294 162.608 L 178.294 162.608 L 178.294 162.608 Q 178.722 162.154 178.722 161.401 L 178.722 161.401 L 178.722 156.505 L 180.999 156.505 L 180.999 163.404 L 180.999 163.404 Q 180.999 164.208 181.085 164.927 L 181.085 164.927 L 181.085 164.927 Z  M 188.617 156.505 L 191.595 156.505 L 188.223 160.048 L 191.664 164.927 L 188.873 164.927 L 186.648 161.709 L 185.707 162.702 L 185.707 164.927 L 183.43 164.927 L 183.43 152.534 L 185.707 152.534 L 185.707 159.638 L 188.617 156.505 L 188.617 156.505 Z  M 195.276 156.505 L 195.276 164.927 L 192.999 164.927 L 192.999 156.505 L 195.276 156.505 L 195.276 156.505 Z  M 192.725 153.749 L 192.725 153.749 L 192.725 153.749 Q 192.725 153.167 193.136 152.748 L 193.136 152.748 L 193.136 152.748 Q 193.547 152.328 194.129 152.328 L 194.129 152.328 L 194.129 152.328 Q 194.711 152.328 195.122 152.739 L 195.122 152.739 L 195.122 152.739 Q 195.532 153.15 195.532 153.749 L 195.532 153.749 L 195.532 153.749 Q 195.532 154.314 195.122 154.725 L 195.122 154.725 L 195.122 154.725 Q 194.711 155.136 194.129 155.136 L 194.129 155.136 L 194.129 155.136 Q 193.547 155.136 193.136 154.725 L 193.136 154.725 L 193.136 154.725 Q 192.725 154.314 192.725 153.749 Z  M 201.609 154.417 L 201.609 154.417 L 201.609 154.417 Q 201.13 154.417 200.779 154.682 L 200.779 154.682 L 200.779 154.682 Q 200.428 154.947 200.428 155.581 L 200.428 155.581 L 200.428 156.505 L 202.328 156.505 L 202.328 158.456 L 200.428 158.456 L 200.428 164.927 L 198.134 164.927 L 198.134 158.456 L 196.731 158.456 L 196.731 156.505 L 198.134 156.505 L 198.134 155.546 L 198.134 155.546 Q 198.134 154.126 198.965 153.27 L 198.965 153.27 L 198.965 153.27 Q 199.795 152.414 201.198 152.414 L 201.198 152.414 L 201.198 152.414 Q 201.952 152.414 202.328 152.585 L 202.328 152.585 L 202.328 154.502 L 202.328 154.502 Q 202.037 154.417 201.609 154.417 Z  M 212 156.505 L 206.711 168.248 L 204.297 168.248 L 206.283 163.866 L 202.705 156.505 L 205.255 156.505 L 207.498 161.435 L 209.569 156.505 L 212 156.505 L 212 156.505 Z "
                  fillRule="evenodd"
                  fill={color2}
                />
              </g>
            </g>
          </g>
        </animated.g>
        <g
          filter="url(#EJot5R3pp9E0XT9TDbNZCyFaTliX6pSu)"
          transform={`rotate(${((props.progress || 0) / 1000 / 360) * -20}, 303.666, 0)`}
        >
          <path
            d=" M 303.666 -6.748 C 306.512 -21.959 321.172 -31.998 336.383 -29.153 C 351.594 -26.307 361.634 -11.647 358.788 3.564 C 355.942 18.775 341.282 28.815 326.071 25.969 C 310.86 23.123 300.821 8.464 303.666 -6.748 Z "
            fill="rgb(160,155,151)"
          />
          <path
            d=" M 319.778 3.134 C 263.171 28.535 229.443 3.764 179.219 14.672 C 151.9 20.606 144.139 29.245 96.976 70.272"
            fill="none"
            vectorEffect="non-scaling-stroke"
            strokeWidth="10"
            stroke="rgb(160,155,151)"
            strokeLinejoin="miter"
            strokeLinecap="square"
            strokeMiterlimit="3"
          />
          <rect
            x="59.27"
            y="78.972"
            width="28.039"
            height="29.077"
            transform="matrix(0.673,0.74,-0.74,0.673,93.12,-23.631)"
            fill="rgb(42,54,52)"
          />
          <rect
            x="84.985"
            y="35.352"
            width="20.77"
            height="75.809"
            transform="matrix(0.673,0.74,-0.74,0.673,85.354,-46.583)"
            fill="rgb(42,54,52)"
          />
          <rect
            x="60.687"
            y="84.425"
            width="7.145"
            height="12.862"
            transform="matrix(0.673,0.74,-0.74,0.673,88.204,-17.821)"
            fill="rgb(160,155,151)"
          />
          <rect
            x="71.154"
            y="95.667"
            width="7.145"
            height="12.862"
            transform="matrix(0.673,0.74,-0.74,0.673,99.941,-21.887)"
            fill="rgb(160,155,151)"
          />
        </g>
        <defs>
          <filter
            id="EJot5R3pp9E0XT9TDbNZCyFaTliX6pSu"
            x="-200%"
            y="-200%"
            width="400%"
            height="400%"
            filterUnits="objectBoundingBox"
            colorInterpolationFilters="sRGB"
          >
            <feGaussianBlur
              xmlns="http://www.w3.org/2000/svg"
              in="SourceGraphic"
              stdDeviation="0"
            />
            <feOffset
              xmlns="http://www.w3.org/2000/svg"
              dx="0"
              dy="-4"
              result="pf_100_offsetBlur"
            />
            <feFlood xmlns="http://www.w3.org/2000/svg" floodColor="#000000" floodOpacity="0.65" />
            <feComposite
              xmlns="http://www.w3.org/2000/svg"
              in2="pf_100_offsetBlur"
              operator="in"
              result="pf_100_dropShadow"
            />
            <feBlend
              xmlns="http://www.w3.org/2000/svg"
              in="SourceGraphic"
              in2="pf_100_dropShadow"
              mode="normal"
            />
          </filter>
        </defs>
      </g>
    </svg>
  );
}

export default VinylWithPlayerArm;
